import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { ExpenseEffects, expenseReducer } from './store';

@NgModule({
  imports: [EffectsModule.forFeature([ExpenseEffects]), StoreModule.forFeature(`expense`, expenseReducer)]
})
export class ExpenseStateModule {}
